import 'css-chunksrc/client/scenes/assignToTask/tasksSelection/tasks/styles.scss';export default {
  "list": "_list_plh44_1",
  "tasks": "_tasks_plh44_5",
  "loader": "_loader_plh44_11"
};